/** Set up the band space, including children */

import { logger } from '@tunasong/models'
import type { DefaultGlobalContext } from '@tunasong/plugin-lib'
import type { Entity, Persisted } from '@tunasong/schemas'

export const setup = async ({
  entity,
  parent,
  globalContext: { graph },
}: {
  entity: Persisted<Entity>
  parent?: Persisted<Entity> | null
  globalContext: DefaultGlobalContext
  isNew?: boolean
}) => {
  logger.debug('Create Band Space', entity, parent)

  /** @todo for updates we need to check if we already have the children here */

  /** create a calendar for the band space */
  const calendar = await graph.createEntity({
    entity: {
      type: 'calendar',
      name: 'Band calendar',
    },
    parent: entity,
  })

  logger.debug('Created band calendar', calendar)

  /** make an hasCalendar graph edge to the calendar */
  const edge = await graph.createEntityEdge({
    source: entity.id,
    target: calendar.id,
    relation: 'calendar',
  })

  logger.debug('Created edge for band calendar', edge)
}
